/**
 * Formats a timestamp (Unix timestamp in seconds or milliseconds) into a readable date format.
 * Returns a string in the format "Nov 9, 2024".
 *
 * @param timestamp - The timestamp to format (Unix timestamp in seconds or milliseconds)
 * @returns A string representing the formatted date (e.g., "Nov 9, 2024")
 */
export const formatTimestampForDisplay = (timestamp: number): string => {
  const timestampMs =
    timestamp.toString().length <= 10 ? timestamp * 1000 : timestamp;

  const date = new Date(timestampMs);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};
